export interface InactivityConfig {
  // Tiempo de inactividad en minutos (por defecto 5 minutos para testing)
  inactivityTimeoutMinutes: number;

  // Tiempo de advertencia en minutos antes del cierre (por defecto 1 minuto)
  warningTimeoutMinutes: number;

  // Si se debe mostrar advertencias (por defecto false según el requerimiento)
  showWarnings: boolean;

  // Eventos que se consideran como actividad del usuario
  activityEvents: string[];
}

export const DEFAULT_INACTIVITY_CONFIG: InactivityConfig = {
  inactivityTimeoutMinutes: 60, // 5 minutos para testing
  warningTimeoutMinutes: 60,    // 1 minuto antes del cierre
  showWarnings: false,         // Sin notificaciones según el requerimiento
  activityEvents: [
    'mousedown',
    'mousemove',
    'keypress',
    'scroll',
    'touchstart',
    'click'
  ]
};

// Configuración para producción (2 horas)
export const PRODUCTION_INACTIVITY_CONFIG: InactivityConfig = {
  ...DEFAULT_INACTIVITY_CONFIG,
  inactivityTimeoutMinutes: 60, // 2 horas
  warningTimeoutMinutes: 5       // 5 minutos antes del cierre
};
